import 'css-chunksrc/client/pages/documentsPage/sideBar/styles.scss';export default {
  "sideBar": "_sideBar_fakm6_1",
  "link": "_link_fakm6_12",
  "active": "_active_fakm6_23",
  "icon": "_icon_fakm6_26"
};